/* Session-only handles first; published-product cards fill remaining slots. */
(() => {
  if (customElements.get('catalog-recent')) return;

  const HANDLE = /^[a-z0-9][a-z0-9_-]*$/i;

  const cardHandle = (card) => {
    const marked = card.querySelector('[data-mto-wishlist]')?.dataset.mtoWishlist;
    if (marked) return marked;
    const href = card.querySelector('a[href]')?.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  customElements.define('catalog-recent', class extends HTMLElement {
    async connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.request = new AbortController();
      const key = 'magnifissance:recent-products:v1';
      let previous = [];
      try {
        const stored = JSON.parse(sessionStorage.getItem(key) || '[]');
        previous = [...new Set(Array.isArray(stored) ? stored : [])]
          .filter((handle) => typeof handle === 'string' && HANDLE.test(handle) && handle !== this.dataset.handle)
          .slice(0, 4);
        sessionStorage.setItem(key, JSON.stringify([this.dataset.handle, ...previous].slice(0, 12)));
      } catch { /* keep fallback cards */ }

      const grid = this.querySelector('[data-recent-grid]');
      if (!grid) return;
      const fallback = [...grid.querySelectorAll('.mto-card')];
      const historyCards = (await Promise.all(previous.map((handle) => this.fetchCard(handle)))).filter(Boolean);
      const used = new Set(historyCards.map(cardHandle));
      const extras = fallback.filter((card) => {
        const handle = cardHandle(card);
        return handle && handle !== this.dataset.handle && !used.has(handle);
      });
      const cards = [...historyCards, ...extras].slice(0, 4);
      if (!this.isConnected) return;
      if (cards.length) grid.replaceChildren(...cards);
      this.hidden = !grid.querySelector('.mto-card');
    }
    async fetchCard(handle) {
      try {
        const url = new URL(`${this.dataset.productRoot.replace(/\/?$/, '/')}products/${handle}`, location.origin);
        url.searchParams.set('view', 'catalog-card');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) return null;
        return new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.mto-card');
      } catch {
        return null;
      }
    }
    disconnectedCallback() { this.request?.abort(); this.loaded = false; }
  });
})();
